<template>
  <div class="Denmark-view">
    <h1>Denmark</h1>

    <div class="row">
      <!-- Adm Office -->
      <div class="section">
        <h2>Adm Office - Lansen 19</h2>
      </div>

      <div class="divider"></div>

      <!-- Warehouse -->
      <div class="section">
        <h2>Warehouse - Lansen 11</h2>
      </div>
    </div>

    <!-- For testing data -->
    <div>
      <h1>Testing Endpoint Data</h1>
      <p v-if="loading">Loading departments…</p>
      <p v-else-if="error">Could not load departments: {{ error }}</p>
      <p v-else-if="departments.length === 0">No departments registered for DK yet.</p>

      <ul v-else>
        <li v-for="dept in departments" :key="dept.department_id">
          {{ dept.department_name }}
        </li>
      </ul>
    </div>


  </div>
</template>


<script setup>
import { ref, onMounted } from 'vue'
import EmployeeService, { COUNTRY } from '@/services/EmployeeService'

// reactive state
const departments = ref([])
const loading = ref(false)
const error = ref(null)

// lifecycle
onMounted(async () => {
  loading.value = true
  try {
    const response = await EmployeeService.getDepartmentNames(COUNTRY.DENMARK)

    // The backend always wraps payloads in an envelope:
    //   { "status": "success", "departments": [ ... ] }
    // on failure:
    //   { "status": "failed", "error_code": 1002, "message": "..." }
    // The old code did an Array.isArray check on response.data and wrapped the
    // whole envelope in an array, so the list rendered one empty row.
    if (response.data?.status !== 'success') {
      throw new Error(response.data?.message ?? 'Request failed')
    }

    departments.value = response.data.departments ?? []

  } catch (err) {
    console.error(err)
    error.value = err.message ?? String(err)
  } finally {
    loading.value = false
  }
})
</script>


<style scoped>
.row {
  display: flex;
  align-items: center;
}

.section {
  flex: 1;
  text-align: center;
}

.divider {
  width: 2px;
  height: 100px;
  background-color: #ccc;
  margin: 0 20px;
  align-self: stretch;
}
</style>
